import React from 'react';
import classes from './StateButton.css';

const stateButton = (props) => {

    let checkIcon = null;
    let classList = [classes.AllocationStateButton];

    if (props.isActive) {
        checkIcon = (
            <div name="checkedIcon" className={classes.checkIcon}><i className="fas fa-check"></i></div>
        );

        classList.push(classes.AllocationStateButtonCurrent)
    }

    return (
        <div onClick={props.click} name="defaultStateButton" className={classList.join(" ")}>
            {checkIcon}
            <label>{props.label}</label>
        </div>
    );
};

export default stateButton;


// WEBPACK FOOTER //
// ./src/components/StateButton/StateButton.js